// extracted by mini-css-extract-plugin
module.exports = {"ExtraControls":"_1Uf14","ExtraControls__Button":"NVfd7","ExtraControls__Icon_open":"s9zgi","ExtraControls__Icon_copy":"IBSYk"};